import { createElement } from 'react';
import classNames from 'classnames';

const createContainer = (name, className) => {
  const Container = props =>
    createElement('div', {
      ...props,
      className: classNames(className, props.className),
    });
  Container.displayName = `Layout(${name})`;
  return Container;
};

function createLayout(containers) {
  const compound = {};
  Object.entries(containers).forEach(([name, className]) => {
    compound[name] = createContainer(name, className);
  });
  return compound;
}

/**
 * This will generates the following compound components:
 *
 * ┌─ Layout.Dashboard ───────────────────────────────┐
 * │ ┌─ Layout.Header ──────────────────────────────┐ │
 * │ │                                              │ │
 * │ └──────────────────────────────────────────────┘ │
 * │ ┌─ Layout.Main ────────────────────────────────┐ │
 * │ │ ┌─ Layout.Side ─┐ ┌─ Layout.Content ───────┐ │ │
 * │ │ │               │ │                        │ │ │
 * │ │ │               │ │                        │ │ │
 * │ │ └───────────────┘ └────────────────────────┘ │ │
 * │ └──────────────────────────────────────────────┘ │
 * └──────────────────────────────────────────────────┘
 */
export default createLayout({
  Dashboard: 'LearnDashboard',
  Main: 'LearnDashboard-main',
  Header: 'LearnDashboard-header PageHero PageHero--dark PageHero--small',
  Side: 'LearnDashboard-side',
  Content: 'LearnDashboard-content',
});
